const refs = 'projects'
const refs2 = 'categories'
export default [
  {
    path: "/projects-list/:id",
    name: "projects",
    component: () => import("@/views/" + refs + "/Projects.vue"),
  },
  {
    path: "/categories",
    name: "categories",
    component: () => import("@/views/" + refs + "/Categories.vue"),
  },
  {
    path: "/"+ refs2 +"/:cat",
    name: 'show-'+refs2,
    component: () => import("@/views/" + refs + "/Country.vue"),
  },
  {
    path: "/"+ refs2 +"/:cat/country/:country_id",
    name: 'show-country-'+refs,
    component: () => import("@/views/" + refs + "/List.vue"),
  },
  {
    path: "/mongezProjects",
    name: 'categories1',
    component: () => import("@/views/" + refs + "/CompletedProjects.vue"),
  },
  {
    path: "/notMongezProjects",
    name: 'categories2',
    component: () => import("@/views/" + refs + "/ProjectsInProgress.vue"),
  },
  // {
  //     path: '/'+refs+'/:cat/:id',
  //     name: 'show-'+refs,
  //     component: () => import('@/views/'+refs+'/Show.vue')
  // },
  // {
  //   path: "/" + refs + "/:slug/:id",
  //   name: "show-" + refs,
  //   component: () => import("@/views/" + refs + "/Show.vue"),
  // },
  {
    path: "/" + refs + "/:slug",
    name: "show-" + refs,
    component: () => import("@/views/" + refs + "/Show.vue"),
  },
];
